import React from 'react'
import { Route, IndexRoute, IndexRedirect } from 'react-router'
import Agents from './views/Agents'
import authenticate from './containers/Authenticate'
import authenticateAdmin from './containers/AuthenticateAdmin'
import Admin from './containers/Admin'
import AdminClients from './views/AdminClients'
import AdminIndex from './views/AdminIndex'
import AdminNewsletterRecipients from './views/AdminNewsletterRecipients'
import AdminUser from './containers/AdminUser'
import AdminUserOffers from './views/AdminUserOffers'
import AdminUserTours from './views/AdminUserTours'
import AdminUserFavorites from './views/AdminUserFavorites'
import AdminUserAlerts from './views/AdminUserAlerts'
import App from './containers/App'
import BuyAnyHome from './views/BuyAnyHome'
import BuyingWithUs from './views/BuyingWithUs'
import Dashboard from './containers/Dashboard'
import FacebookCallback from './views/FacebookCallback'
import Faq from './views/Faq'
import ForgotPassword from './views/ForgotPassword'
import HireUs from './views/HireUs'
import Home from './views/Home'
import KiefRealtyDifference from './views/KiefRealtyDifference'
import Login from './views/Login'
import NotFound from './views/NotFound'
import NewOffer from './views/NewOffer'
import NewTour from './views/NewTour'
import OpenHouses from './views/OpenHouses'
import ResetPassword from './views/ResetPassword'
import Search from './views/Search'
import Sell from './views/Sell'
import Signup from './views/Signup'
import PrivacyPolicy from './views/PrivacyPolicy'
import Property from './views/Property'
import Rebate from './views/Rebate'
import redirectAuthenticated from './containers/RedirectAuthenticated'
import TermsOfService from './views/TermsOfService'
import PropertyTours from './views/PropertyTours'
import UserFavorites from './views/UserFavorites'
import UserOffers from './views/UserOffers'
import UserSettings from './views/UserSettings'
import UserSearches from './views/UserSearches'
import UserTours from './views/UserTours'
import Welcome from './views/Welcome'

export default (
  <Route path="/" component={App}>
    <IndexRoute component={Home} />
    <Route path="/login" component={redirectAuthenticated(Login)} />
    <Route path="/signup" component={redirectAuthenticated(Signup)} />
    <Route path="/forgot" component={redirectAuthenticated(ForgotPassword)} />
    <Route path="/reset" component={redirectAuthenticated(ResetPassword)} />
    <Route path="/privacy-policy" component={PrivacyPolicy} />
    <Route path="/terms-of-service" component={TermsOfService} />
    <Route path="/faq" component={Faq} />
    <Route path="/buy-any-home" component={BuyAnyHome} />
    <Route path="/buying-with-us" component={BuyingWithUs} />
    <Route path="/kief-realty-difference" component={KiefRealtyDifference} />
    <Route path="/rebate" component={Rebate} />
    <Route path="/agents" component={Agents} />
    <Route path="/sell" component={Sell} />
    <Route path="/hire-us" component={HireUs} />
    <Route path="/welcome" component={Welcome} />
    <Route path="/offer/:mlsId" component={authenticate(NewOffer)} />
    <Route path="/tour/:mlsId" component={authenticate(NewTour)} />
    <Route path="/properties" component={Search} />
    <Route path="/tours" component={PropertyTours} />
    <Route path="/open-houses" component={OpenHouses} />
    <Route path="/properties/:mlsId" component={Property} />
    <Route component={authenticate(Dashboard)}>
      <Route path="/favorites" component={UserFavorites} />
      <Route path="/offers" component={UserOffers} />
      <Route path="/searches" component={UserSearches} />
      <Route path="/settings" component={UserSettings} />
      <Route path="/scheduled-tours" component={UserTours} />
    </Route>
    <Route path="/admin" component={authenticateAdmin(Admin)}>
      <IndexRoute component={AdminIndex} />
      <Route path="/admin/clients" component={AdminClients} />
      <Route path="/admin/newsletter" component={AdminNewsletterRecipients} />
      <Route path="/admin/u/:userId" component={AdminUser}>
        <IndexRedirect to="/admin/u/:userId/offers" />
        <Route path="/admin/u/:userId/offers" component={AdminUserOffers} />
        <Route
          path="/admin/u/:userId/scheduled-tours"
          component={AdminUserTours}
        />
        <Route
          path="/admin/u/:userId/favorites"
          component={AdminUserFavorites}
        />
        <Route path="/admin/u/:userId/alerts" component={AdminUserAlerts} />
      </Route>
    </Route>
    <Route path="/auth/facebook/callback" component={FacebookCallback} />
    <Route path="*" component={NotFound} />
  </Route>
)



// WEBPACK FOOTER //
// ./src/routes.js